<app-loader
  class="loader"
  [ngStyle]="{ display: loaderDisplayStyle }"
></app-loader>
<div class="former">
  <div class="hall">
    <app-dash-nav></app-dash-nav>
  </div>

  <app-ideas-inner
    (isLoading)="changeLoaderDisplayState($event)"
    (isFinished)="onSubmit()"
    [showSkip]="false"
  ></app-ideas-inner>
</div>

<!-- MODAL2 -->
<!--   ADD TEAM MEMBER    -->
